<div class="radio-display-container">
  <div class="radio-display-content">
    <cs-label class="radio-display-label">{{ label }}</cs-label>
    <div class="radio-display-value-wrapper">
      <cs-label class="radio-display-value">{{ value }}@if (customText) {
        <span>, {{ customText }}</span>
      }</cs-label>
      @if (description) {
        <cs-tooltip small iconType="help" [text]="description"></cs-tooltip>
      }
      <ng-content select="cs-tooltip"></ng-content>
      <ng-content select="cs-badge"></ng-content>
    </div>
    <!-- an optional line under the value, for a fact about the choice that the value alone does not say -->
    <ng-content select="[radioDisplayNote]"></ng-content>
  </div>
</div>
